import React from "react";
import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="bg-brand-green text-white/90 mt-auto">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="font-serif text-2xl font-semibold text-white">Rehoboth Wealth Group</div>
          <p className="text-sm text-white/60 mt-2 max-w-xs">Financial Awareness. Financial Security. Financial Freedom.</p>
          <p className="text-sm text-white/60 mt-4">clientsupport@rehowealth.co.uk</p>
        </div>
        <div>
          <div className="text-brand-gold text-xs tracking-widest font-semibold mb-3">LEGAL</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy-notice" className="hover:text-brand-gold transition-colors" data-testid="footer-privacy-link">Privacy Notice</Link></li>
            <li><Link to="/terms-of-business" className="hover:text-brand-gold transition-colors" data-testid="footer-terms-link">Terms of Business</Link></li>
            <li><Link to="/guide-to-service" className="hover:text-brand-gold transition-colors" data-testid="footer-guide-link">Guide to the Service</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-brand-gold text-xs tracking-widest font-semibold mb-3">GET STARTED</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-brand-gold transition-colors">Create an account</Link></li>
            <li><Link to="/login" className="hover:text-brand-gold transition-colors">Client sign in</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-4 text-xs text-white/50">
          © {new Date().getFullYear()} Rehoboth Wealth Group. This portal records your instructions and does not itself constitute a legal document.
        </div>
      </div>
    </footer>
  );
}
